import PairedComparisonDownload from './PairedComparisonDownload';
export default PairedComparisonDownload;
